import { render, staticRenderFns } from "./SnowFall.vue?vue&type=template&id=12096c4b&"
import script from "./SnowFall.vue?vue&type=script&lang=ts&"
export * from "./SnowFall.vue?vue&type=script&lang=ts&"
import style0 from "./SnowFall.vue?vue&type=style&index=0&id=12096c4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports